import React from 'react'

function PageTitle({title}) {
  return (
    <div>{title}</div>
  )
}

export default PageTitle